
    import I18n from 'i18nObj';
    
      import 'translations/assignments.never_drop_collection';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('assignments.never_drop_collection');
  